import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/tenders/EditTenderForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import * as _ from 'lodash';
import classNames from 'classnames';
import Input from '../../components/Input';
import DateTimePicker from '../../components/DateTimePicker';
import Textarea from '../../components/Textarea';
import PeopleChooser from '../../components/PeopleChooser';

import Select from '../../components/Select';
import MultiSelect from '../../components/MultiSelect';
import PlusMiddleIcon from '../../assets/images/plus-middle-15x15.svg';
import { listPossibleTags } from '../../redux/actions/general';
import {
  listPossibleTenderAdministrators,
  listPossibleTenderFollowers,
} from '../../redux/actions/table/tenders';

@reduxForm({
  form: 'tenders.edit_tender',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['tenders'],
  user_id: state.auth.id,
}))
@subscribe(Localization, 'localization')
class EditTenderForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_tender_administrators: [],
      possible_tender_followers: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {
    listPossibleTenderAdministrators(
      this.props.match.params.stage || this.props.table.stage_id
    ).then(({ response }) => {
      this.setState({ possible_tender_administrators: response.data });
    });

    listPossibleTenderFollowers(
      this.props.match.params.stage || this.props.table.stage_id
    ).then(({ response }) => {
      this.setState({ possible_tender_followers: response.data });
    });
  }

  render() {
    const { data, user_id } = this.props;
    const { project_languages, status } = data;
    const is_administrator = _.isObject(
      _.find(data.administrators, ['id', user_id])
    );

    const disabled =
      !is_administrator || _.includes(['closed', 'canceled'], status);

    const languages = _.map(project_languages, (primary, language_id) => ({
      label: _.get(this.props.localization.languages, [language_id, 'name']),
      value: language_id,
    }));

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                disabled={disabled}
                name='title'
                component={Input}
                localized={project_languages}
                label={__('table.columns.tender-title')}
                maxLength={50}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='languages'
                component={MultiSelect}
                searchable
                label={__('Tender Languages')}
                noSort
                options={languages}
              />
            </div>
          </div>
          <Field
            disabled={disabled}
            name='description'
            component={Textarea}
            localized={project_languages}
            label={__('table.columns.tender-description')}
            maxLength={1000}
            rows={1}
            maxRows={10}
          />

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='start_date'
                component={DateTimePicker}
                label={__('tenders.edit-tender-form.start_date')}
                footer
                clearDate
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={true}
                name='duration'
                component={Input}
                label={__('Duration Estimate')}
                numeric
                maxLength={4}
                hint={__('tenders.hint.in-minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='end_date'
                component={DateTimePicker}
                label={__('Submission date')}
                footer
              />
            </div>

            <div className={styles.f1}>
              <Field
                name='remaining_days'
                component={Input}
                label={__('table.columns.tender-remaining-estimate')}
                hint={__('tender.hint.in-days')}
                disabled
              />
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='question_date'
                component={DateTimePicker}
                label={__('tenders.edit-tender-form.question_date')}
                footer
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='result_date'
                component={DateTimePicker}
                label={__('tenders.edit-tender-form.result_date')}
                footer
              />
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='administrators'
                component={PeopleChooser}
                label={__('table.columns.tender-administrators')}
                searchable
                options={this.state.possible_tender_administrators}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='followers'
                component={PeopleChooser}
                label={__('table.columns.tender-followers')}
                searchable
                options={this.state.possible_tender_followers}
              />
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default EditTenderForm;
